import { initExternalControl } from './modules/external-control';
import { selectors } from './modules/lib';
import { initAudioPlayer } from './modules/player';

// TODO: Fix bug of seek slider in media session being stuck at the end.

const audioPlayers = document.querySelectorAll(selectors.player);
audioPlayers.forEach((player) => {
	// Initialize custom audio player.
	initAudioPlayer(player);

	// Initialize possible external control.
	initExternalControl(player);
});
